type ExpectedMeter = {
	expectedKm: number | null;
	expectedHours: number | null;
};

// Predicted km and/or usage hours of a maintenance (an asset can count both), ex.: "98 000 km · 50 h".
// Empty string when there is none.
export const formatExpectedMeter = (item: ExpectedMeter, hoursSymbol: string) => [
	item.expectedKm != null ? `${item.expectedKm.toLocaleString()} km` : null,
	item.expectedHours != null ? `${item.expectedHours.toLocaleString(undefined, { maximumFractionDigits: 1 })} ${hoursSymbol}` : null,
].filter(Boolean).join(' · ');

export default formatExpectedMeter;
